import { EmployeeTable } from "../../../../components/table/Employee/EmployeeTable"

const PlanEmployees = ({ planId }: { planId: string }) => {
    return (<EmployeeTable planId={planId} />)
}

export { PlanEmployees }